import { useLingui } from "@lingui/react/macro";
import { captureWorkspaceHandoff, workspaceHandoffLink } from "@rakazo/contracts";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  Input,
} from "@rakazo/ui-web";
import { Copy, Share2 } from "lucide-react";
import { useRef, useState } from "react";
import { selectedSpaceId } from "../lib/rpc";
import { errorText } from "../lib/user-error";

export function WorkspaceHandoff({ path }: { path: string }) {
  const { t } = useLingui();
  const [open, setOpen] = useState(false);
  const copyButton = useRef<HTMLButtonElement>(null);
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState("");
  const reference = captureWorkspaceHandoff(path, "web", selectedSpaceId());
  const link = reference ? workspaceHandoffLink(window.location.origin, reference) : null;
  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        className="w-full justify-start gap-2"
        onClick={() => {
          setCopied(false);
          setError("");
          setOpen(true);
        }}
      >
        <Share2 size={15} />
        {t`Continue elsewhere`}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent initialFocus={copyButton}>
          <DialogTitle>{t`Continue elsewhere`}</DialogTitle>
          <DialogDescription>
            {link
              ? t`Open this link on your other device. Unsaved edits stay here.`
              : t`Save this file before continuing on another device.`}
          </DialogDescription>
          {link && (
            <>
              <Input
                aria-label={t`Saved workspace link`}
                value={link}
                readOnly
                onFocus={(event) => event.target.select()}
              />
              <Button
                ref={copyButton}
                onClick={() => {
                  void navigator.clipboard.writeText(link).then(
                    () => setCopied(true),
                    (error) => setError(errorText(error)),
                  );
                }}
              >
                <Copy size={15} />
                {copied ? t`Copied` : t`Copy link`}
              </Button>
            </>
          )}
          {error && (
            <p role="alert" className="text-xs text-destructive">
              {error}
            </p>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
